export default __webpack_public_path__ + "static/media/proj4.6bb2b3ff.png";